const animatePostHeader = () => {
  const postHeader = document.querySelector('.post-header--featured');
  const header = document.querySelector('.header');

  if (!postHeader) {
    return;
  }

  requestAnimationFrame(() => {
    if (window.scrollY < postHeader.offsetHeight + header.offsetHeight) {
      postHeader.style.zIndex = 'initial';
      postHeader.style.transform = `translate3d(0, ${window.scrollY / 3}px, 0)`;
    } else {
      postHeader.style.zIndex = '-100000';
    }
  });
};

export { animatePostHeader };
